export const BASE_URL = 'https://sound-wave.b.goit.study/api';
export const FEEDBACKS_LIMIT = 10;
export const DEFAULT_PAGE = 1;

export const ARTIST_LIMIT = 8;
